import TourTooltip from 'elements/tooltip/TourTooltip'
import { TourConfigType } from 'persistentContent/tours/types'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

const StepTooltip: FC = (props) => {
  const translate = useTranslate()
  return (
    <TourTooltip
      title={translate('Chat Menu')}
      subtext={translate(
        'Access chat settings, clear your conversation, leave feedback, manage whitelisted actions, and take the tour again anytime.'
      )}
      {...props}
    />
  )
}

const ChatHeaderMenu: TourConfigType = {
  spotlights: [{ targetId: 'Ada-Chat-Menu-Button', autoScroll: true }],
  tooltips: [
    {
      targetId: 'Ada-Chat-Menu-Button',
      placement: 'top-start',
      component: StepTooltip,
      options: { style: { marginBottom: 10 } },
    },
  ],
}

export default ChatHeaderMenu
